import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {VjsPlayerComponent} from "./videojsplayer.component";



@NgModule({
  declarations: [
    VjsPlayerComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    VjsPlayerComponent
  ],
  providers: [

  ]
})
export class VideojsplayerModule { }
